import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import { ContactUsInsert } from "../../api/contactUsService";
import CommonToastContainer from "../../components/Common/CommonToastContainer";
import FullScreenLoader from "../../components/Common/Loader";

const ContactUsSection = () => {
	document.title = "Contact Us";

	const [fbTooltip, setFbTooltip] = useState(false);
	const [twTooltip, setTwTooltip] = useState(false);
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		subject: "",
		message: ""
	});
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({});
	const [touched, setTouched] = useState({});
	const [toasts, setToasts] = useState([]);

	const showToast = (toastData) => {
		setToasts(prev => [...prev, { id: Date.now(), ...toastData }]);
	};

	const removeToast = (id) => {
		setToasts(prev => prev.filter(t => t.id !== id));
	};

	const validateField = (name, value) => {
		let error = "";

		if (name === "name" && !value.trim())
			error = "Please enter your full name";

		if (name === "email") {
			if (!value.trim()) error = "Email is required";
			else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
				error = "Enter a valid email address";
		}

		if (name === "subject" && !value.trim())
			error = "Please enter subject";

		if (name === "message" && !value.trim())
			error = "Please enter message";

		setErrors(prev => ({ ...prev, [name]: error }));
	};

	const validateForm = () => {
		const newErrors = {};

		Object.keys(formData).forEach(key => {
			if (!formData[key].trim())
				newErrors[key] = `Please enter ${key}`;
		});

		if (
			formData.email &&
			!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
		) {
			newErrors.email = "Enter a valid email address";
		}

		setErrors(newErrors);
		setTouched({
			name: true,
			email: true,
			subject: true,
			message: true
		});

		return Object.keys(newErrors).length === 0;
	};

	const handleBlur = (e) => {
		const { name, value } = e.target;
		setTouched(prev => ({ ...prev, [name]: true }));
		validateField(name, value);
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData(prev => ({ ...prev, [name]: value }));
		if (touched[name]) validateField(name, value);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validateForm()) return;
		setLoading(true);
		const payload = {
			FullName: formData.name.trim(),
			EmailId: formData.email.trim(),
			Subject: formData.subject.trim(),
			Message: formData.message.trim()
		};

		try {
			const result = await ContactUsInsert(payload);
			const msgObj = result?.Message?.[0];
			if (msgObj?.ReturnCode === "1") {
				showToast({
					title: "Success!",
					message: msgObj?.ReturnMessage,
					type: "success",
				});
				setFormData({ name: "", email: "", subject: "", message: "" });
				setTouched({});
				setErrors({});
			} else {
				showToast({
					title: "Error!",
					message: msgObj?.ReturnMessage || "Unable to send message.",
					type: "error",
				});
			}
		} catch {
			showToast({
				title: "Error!",
				message: "Something went wrong. Please try again later.",
				type: "error",
			});
		}
		setLoading(false);
	};

	return (
		<>
			<div className="contact-section py-3 overflow-hidden">
				{loading && <FullScreenLoader />}
				<div className="container">
					<div className="row align-items-start">
						<div className="col-lg-6 mb-5 mb-lg-0" data-aos="fade-in">
							<h2 className="contact-title mb-4">
								We are always ready <br /> to help you and <br /> answer your questions
							</h2>
							<p className="contact-desc mb-5">
								We value your enquiries connect with us for
								guidance, support, and personalized assistance today.
							</p>
							<div className="row">
								<div className="row">
									<div className="col-md-6">
										<div className="our-location">
											<h3 className="contact-heading">Our Locations</h3>
											<h6 className="fw-bold text-muted">Head Office - Mumbai</h6>
											<a
												href="https://www.google.com/maps/place/Meera+Jewellery+House+LLP/@19.1229392,72.8629935,17z/data=!4m14!1m7!3m6!1s0x3be7c9538da64c97:0x45bc978da687e00f!2sMeera+Jewellery+House+LLP!8m2!3d19.1229291!4d72.8630042!16s%2Fg%2F11x_832cbg!3m5!1s0x3be7c9538da64c97:0x45bc978da687e00f!8m2!3d19.1229291!4d72.8630042!16s%2Fg%2F11x_832cbg?entry=ttu&g_ep=EgoyMDI1MTAyOS4yIKXMDSoASAFQAw%3D%3D"
												target="_blank"
												rel="noopener noreferrer"
												className="text-dark text-decoration-none"
											>
												<p className="mb-1">2th Floor, Brahans Bussiness Center,</p>
												<p className="mb-0">Off Mahakali Caves Road, Andheri east,</p>
												<p className="mb-3">Mumbai, Maharastra - 400093</p>
											</a>
											<h6 className="fw-bold text-muted">Factory - Surat</h6>
											<a
												href="https://www.google.com/maps?q=3rd+Floor,+Plot+No.+10,+Near+Hira+Nagar,+Ashwini+Kumar+Road,+Varachha,+Surat,+Gujarat+395008"
												target="_blank"
												rel="noopener noreferrer"
												className="text-dark text-decoration-none"
											>
												<p className="mb-1">3rd Floor, Plot No. 10, Near Hira Nagar,</p>
												<p className="mb-0">Ashwini Kumar Road, Varachha,</p>
												<p className="mb-3">Surat, Gujarat – 395008</p>
											</a>
											<h6 className="fw-bold text-muted">Branch - Delhi</h6>
											<a
												href="https://www.google.com/maps?q=2448/10,+3rd+Floor,+Street+No.+10,+Gurudwara+Road,+Karol+Bagh,+Delhi+110005"
												target="_blank"
												rel="noopener noreferrer"
												className="text-dark text-decoration-none"
											>
												<p className="mb-1">2448/10, 3rd Floor, Street No. 10,</p>
												<p className="mb-0">Gurudwara Road, Opp. HDFC Bank,</p>
												<p className="mb-3">Karol Bagh, Delhi – 110005, India</p>
											</a>
											<h6 className="fw-bold text-muted">Midamas LLC</h6>
											<a
												href="https://www.google.com/maps?q=64+W+48th+St+%231408,+New+York,+NY+10036,+United+States"
												target="_blank"
												rel="noopener noreferrer"
												className="text-dark text-decoration-none"
											>
												<p className="mb-1">64 W 48th St #1408,</p>
												<p className="mb-0">New York, NY 10036, United States</p>
											</a>
										</div>
									</div>
									<div className="col-md-6">
										<div className="contactus-right">
											<h5 className="contact-heading">Contact No:</h5>
											<p className="mb-2">
												<a
													href="tel:+9102269760000"
													className="text-dark text-decoration-none"
												>
													+91-022-6976 0000  
												</a>
											</p>

											<h5 className="contact-heading">WhatsApp No:</h5>
											<p className="mb-0">
												<a
													href="https://wa.me/919920807125"
													target="_blank"
													rel="noopener noreferrer"
													className="text-dark text-decoration-none"
												>
													+91 99208 07125
												</a>
											</p>
										</div>
										<div className="contactus-right">
											<h5 className="contact-heading">Email</h5>
											<p>
												<a
													href="mailto:inquiries@midamas.in"
													className="text-dark text-decoration-none"
												>
													inquiries@midamas.in
												</a>
											</p>
										</div>
										<div className="col-6 contactus-right">
											<h5 className="contact-heading">Social Network</h5>
											<div className="social-links d-flex">
												<a href="#" id="fbIcon" onClick={(e) => e.preventDefault()}>
													<i className="fab fa-facebook-f"></i>
												</a>
												<Tooltip
													placement="bottom"
													isOpen={fbTooltip}
													target="fbIcon"
													toggle={() => setFbTooltip(!fbTooltip)}
												>
													Available Soon
												</Tooltip>
												<a href="#" id="twIcon" onClick={(e) => e.preventDefault()}>
													<i className="fab fa-twitter"></i>
												</a>
												<Tooltip
													placement="bottom"
													isOpen={twTooltip}
													target="twIcon"
													toggle={() => setTwTooltip(!twTooltip)}
												>
													Available Soon
												</Tooltip>
												<a
													href="https://www.instagram.com/meera_jewelleryhouse/"
													target="_blank"
													rel="noopener noreferrer"
													id="igIcon"
												>
													<i className="fab fa-instagram"></i>
												</a>
												<a
													href="https://www.linkedin.com/company/meera-jewellery-house-llp"
													target="_blank"
													rel="noopener noreferrer"
													id="lnIcon"
												>
													<i className="fab fa-linkedin-in"></i>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-6" data-aos="fade-in">
							<div className="contact-form-card p-4 p-md-5 rounded-4 shadow-sm bg-light">
								<h3 className="form-title mb-2">Get in Touch</h3>
								<p className="form-desc mb-4">
									Let us know how we can help - our team will get back to you shortly.
								</p>
								<form className="d-flex flex-column gap-3" onSubmit={handleSubmit}>
									<div className="contactus-form-field">
										<input
											type="text"
											name="name"
											placeholder="Full name*"
											className="form-input"
											value={formData.name}
											onBlur={handleBlur}
											onChange={handleChange}
										/>
										{touched.name && errors.name && (
											<small className="text-danger fs-6">{errors.name}</small>
										)}
									</div>
									<div className="contactus-form-field">
										<input
											type="email"
											name="email"
											placeholder="Email*"
											className="form-input"
											value={formData.email}
											onBlur={handleBlur}
											onChange={handleChange}
										/>
										{touched.email && errors.email && (
											<small className="text-danger fs-6">{errors.email}</small>
										)}
									</div>
									<div className="contactus-form-field">
										<input
											type="text"
											name="subject"
											placeholder="Subject*"
											className="form-input"
											value={formData.subject}
											onBlur={handleBlur}
											onChange={handleChange}
										/>
										{touched.subject && errors.subject && (
											<small className="text-danger fs-6">{errors.subject}</small>
										)}
									</div>
									<div className="contactus-form-field">
										<textarea
											name="message"
											placeholder="Message*"
											rows="3"
											className="form-input"
											value={formData.message}
											onBlur={handleBlur}
											onChange={handleChange}
										/>
										{touched.message && errors.message && (
											<small className="text-danger fs-6">{errors.message}</small>
										)}
									</div>
									<button
										type="submit"
										className="form-btn d-inline-flex align-items-center gap-2 mt-3"
										disabled={loading}
									>
										{loading ? "Sending..." : "Send a message"}
										<svg xmlns="http://www.w3.org/2000/svg" className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="white">
											<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
										</svg>
									</button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
			<CommonToastContainer
				toasts={toasts}
				removeToast={removeToast}
			/>
		</>
	);
};

export default ContactUsSection;
